// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vue-material-design-icons/styles.css'
import i18n from './plugins/i18n'
import Toast from 'vue-toastification'
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css'

Vue.config.productionTip = false
Vue.use(Vuetify)
const options = {
  position: 'top-center',
  timeout: 3000
  // You can set your default options here
}
Vue.use(Toast, options)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify: new Vuetify(),
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js